import { IconProps } from '../Icon.types';

export const SliderOutlineIcon = ({ width, height, color }: IconProps) => {
  return (
    <svg width={width} height={height} viewBox="0 0 16 16">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.09491 8.53333C4.34736 9.30736 5.07503 9.86667 5.93333 9.86667C6.79164 9.86667 7.51931 9.30736 7.77176 8.53333C9.60339 8.53333 11.435 8.53333 13.2667 8.53333C13.598 8.53333 13.8667 8.2647 13.8667 7.93333C13.8667 7.60196 13.598 7.33333 13.2667 7.33333C11.435 7.33333 9.60339 7.33333 7.77176 7.33333C7.76528 7.31309 7.77395 7.34006 7.77176 7.33333C7.51931 6.55931 6.79164 6 5.93333 6C5.07503 6 4.34736 6.55931 4.09491 7.33333C3.59661 7.33333 3.0983 7.33333 2.6 7.33333C2.26863 7.33333 2 7.60196 2 7.93333C2 8.2647 2.26863 8.53333 2.6 8.53333C3.0983 8.53333 3.59661 8.53333 4.09491 8.53333ZM5.93333 7.2C5.52832 7.2 5.2 7.52832 5.2 7.93333C5.2 8.33834 5.52832 8.66667 5.93333 8.66667C6.33834 8.66667 6.66667 8.33834 6.66667 7.93333C6.66667 7.52832 6.33834 7.2 5.93333 7.2Z"
        fill={color}
      />
    </svg>
  );
};
